/**
     * @desc 查询作品集列表，只有用户自己创建的collection
查询作品集列表，只有用户自己创建的collection
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/collection/getCollectionList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/collection/getCollectionList', params);
}
